var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "small" },
    [
      _c("ChartOptions", {
        staticClass: "c-chart-options",
        on: { selected: _vm.onSelected },
      }),
      _vm._v(" "),
      _c("LineChart", {
        ref: "line",
        attrs: { "chart-data": _vm.datacollection, options: _vm.options },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }